import { Button } from "@/components/ui/button";
import nikitaProfile from "@/assets/nikita-profile.jpg";
const Hero = () => {
  const scrollToBooking = () => {
    document.getElementById('book-session')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="hero" className="section-padding container-custom">
    <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
      <div className="relative flex justify-center order-1 lg:order-none">
        <div className="relative w-[280px] h-[340px] sm:w-[350px] sm:h-[430px] md:w-[380px] md:h-[460px] lg:w-[450px] lg:h-[550px] overflow-hidden shadow-2xl" style={{ borderRadius: '50%' }}>
          <img
            src={nikitaProfile}
            alt="Nikita Singhal - Functional Nutritionist"
            className="w-full h-full object-cover"
            style={{ objectPosition: '50% center' }}
            loading="eager"
            fetchPriority="high"
          />
        </div>
      </div>

      <div className="space-y-4 sm:space-y-6 text-center lg:text-left px-4 lg:px-0">
        <h1 className="text-3xl sm:text-4xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-foreground">
          Nikita Singhal  <span className="italic">Functional Nutritionist & Wellness Coach</span>
        </h1>

        <h2 className="text-lg sm:text-xl md:text-xl lg:text-2xl text-muted-foreground font-semibold">
          Welcome to Renew Santulan- Your Journey to a Balanced, Healthier You
        </h2>
        <p className="text-base md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto lg:mx-0">
          In today's world, it's easy to lose balance — irregular meals, stress, poor sleep, toxins, and sedentary habits take a quiet toll. These disrupt the natural equilibrium your body works hard to maintain. Our goal is simple yet powerful: to help you restore that balance — in a way that's personalized, sustainable, and empowering.
        </p>

        <div className="pt-2">
          <Button
            onClick={scrollToBooking}
            size="lg"
            className="bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-6 text-base sm:text-lg w-full sm:w-auto min-h-[48px]"
          >
            Book a Consultation
          </Button>
        </div>
      </div>
    </div>
  </section>;
};
export default Hero;